import { nodeAjax } from './index'

const getUserInfo = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + 'ticSso/account/getUserInfo', option)
}
const getTotalNum = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + 'ticMember/order/getTotalNum', option)
}
const mergeTopbar = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + 'ticnode/portal/topbar', option)
}
const searchHotWord = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + 'search/hotWord', option)
}
const qryTitle = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + 'solrServer/content/qryTitle', option)
}
const qryNavi = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + 'ticMall/navi/qry', option)
}


const logout = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + 'ticSso/account/logout', option)
}

export {
  getUserInfo,
  getTotalNum,
  mergeTopbar,
  logout,
  searchHotWord,
  qryTitle,
  qryNavi
}
